import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authApi } from '../services/api';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      
      if (!token) {
        setLoading(false);
        return;
      }

      const user = await authApi.getMe(token);
      
      setIsAuthenticated(true);
      setIsAdmin(user.role === 'admin');
      
      // Store role for quick access
      localStorage.setItem('userRole', user.role);
    } catch (error) {
      console.error('ProtectedRoute: Auth check failed:', error);
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userRole');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#be1f1a]"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Home with the login pop-up open; after signing in the visitor lands back here
    // (e.g. the review link in the order e-mails).
    try { sessionStorage.setItem('postLoginRedirect', location.pathname + location.search); } catch { /* private mode */ }
    return <Navigate to="/?login=1" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-red-600 mb-4">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this page.</p>
          <p className="text-sm text-gray-500 mt-2">User role: {localStorage.getItem('userRole') || 'unknown'}</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;